/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S2_Li4Inputs */

const tr_onbilgi_s2_li4 = /** @type {(inputs: Onbilgi_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI tabanlı otomasyon`)
};

const en_onbilgi_s2_li4 = /** @type {(inputs: Onbilgi_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI based automation`)
};

const de_onbilgi_s2_li4 = /** @type {(inputs: Onbilgi_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-gestützte Automatisierung`)
};

const ru_onbilgi_s2_li4 = /** @type {(inputs: Onbilgi_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматизация на основе AI`)
};

/**
* | output |
* | --- |
* | "AI based automation" |
*
* @param {Onbilgi_S2_Li4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s2_li4 = /** @type {((inputs?: Onbilgi_S2_Li4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S2_Li4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s2_li4(inputs)
	if (locale === "de") return de_onbilgi_s2_li4(inputs)
	if (locale === "ru") return ru_onbilgi_s2_li4(inputs)
	return tr_onbilgi_s2_li4(inputs)
});